/**
 * Application version information
 * Values are injected at build time by Vite
 */

// Declare build-time injected values
declare const __BUILD_TIME__: string;
declare const __BUILD_DATE__: string;

// Use build-time injected values with fallbacks for dev
export const APP_VERSION = typeof __BUILD_DATE__ !== 'undefined' 
  ? __BUILD_DATE__ 
  : new Date().toISOString().split('T')[0].replace(/-/g, '.');

export const BUILD_TIMESTAMP = typeof __BUILD_TIME__ !== 'undefined'
  ? __BUILD_TIME__
  : new Date().toISOString();

/**
 * Formats the build date for display
 */
export const getFormattedBuildDate = (): string => {
  try {
    const date = new Date(BUILD_TIMESTAMP);
    return date.toLocaleDateString('en-IN', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return 'Unknown';
  }
};
